<div class="report-image-component">
    <div class="info-report-image">
        <label class="lbl-title">
            Report Image <span class="instructions">Complete or Discard to capture again</span>
        </label>
        <div class="flex-container select-room">
            <div>
                <label class="lbl-info">Select a contiguous Room:</label>
                <cv-dropdown class="d-inline-block mr-1"
                             placeholder="'Select a Room'"
                             [optionText]="'label'"
                             [selectedValue]="reportImage.selectedContiguousRoom"
                             [options]="contiguousRoomsList"
                             (valuesChange)="onSelectContiguousRoom($event)">
                </cv-dropdown>
            </div>
        </div>
    </div>
</div>